import { IUIState, IUIStatePrio } from './IUIState';
import { UICrumbType } from './UICrumb';
import { ILevelState } from '../Level/ILevelState';

export function showPopup(
    state: IUIState,
    popupID: string,
    params: any,
    crumb?: UICrumbType
): IUIState {
    return {
        ...state,
        popupID: popupID,
        params: params,
        crumb: crumb ? { type: crumb } : null,
    };
}

export function hidePopup(
    state: IUIState,
    popupID: string,
    params: any
): IUIState {
    if (popupID === state.popupID) {
        if (state.queue.length > 0) {
            return nextPopup(state);
        } else {
            return {
                ...state,
                popupID: null,
                params: params,
                crumb: null,
            };
        }
    }
    return state;
}

export function hidePrioPopup(
    state: IUIStatePrio,
    popupIDPrio: string,
    paramsPrio: any
): IUIStatePrio {
    if (popupIDPrio === state.popupIDPrio) {
        return {
            ...state,
            popupIDPrio: null,
            paramsPrio: paramsPrio,
        };
    }
    return state;
}

export function queuePopup(
    state: IUIState,
    popupID: string,
    params: any
): IUIState {
    return {
        ...state,
        queue: [
            ...state.queue,
            {
                popupID: popupID,
                params: params,
            },
        ],
    };
}

export function nextPopup(state: IUIState): IUIState {
    return {
        ...state,
        popupID: state.queue[0].popupID,
        params: state.queue[0].params,
        queue: state.queue.slice(1),
    };
}

export function showPrioPopup(
    state: IUIStatePrio,
    popupIDPrio: string,
    paramsPrio: any
): IUIStatePrio {
    return {
        ...state,
        popupIDPrio: popupIDPrio,
        paramsPrio: paramsPrio,
    };
}

export function openMenu(state: IUIState, crumb: UICrumbType) {
    if (state.popupID !== 'sideMenu') return state;

    // TODO: More crumbs.
    return {
        ...state,
        crumb: {
            type: crumb,
        },
    };
}

export function noCoinsPopupID(levelState?: ILevelState): string {
    const popupId = {
        shop: 'shopMenu',
        noCoins: 'noCoinsMenu',
    };

    // desktop - always bypass 'noCoinsMenu'
    return popupId.shop;
}
